import React from 'react'

function TrendingUpIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13.729" height="8.774" viewBox="0 0 13.729 8.774">
            <g id="Icon_feather-trending-up" data-name="Icon feather-trending-up" transform="translate(-0.086 -7.586)">
                <path id="Path_25994" data-name="Path 25994" d="M12.4,9,7.694,13.707,5.216,11.23,1.5,14.946" fill="none" stroke="#2bbc30" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                <path id="Path_25995" data-name="Path 25995" d="M25.5,9h2.973v2.973" transform="translate(-16.072)" fill="none" stroke="#2bbc30" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
            </g>
        </svg>
    )
}

export default TrendingUpIcon